import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Flame } from 'lucide-react';
export function OfferBar() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 30,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          minutes,
          seconds
        } = prev;
        seconds -= 1;
        if (seconds < 0) {
          seconds = 59;
          minutes -= 1;
        }
        if (minutes < 0) {
          minutes = 0;
          seconds = 0;
        }
        return {
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="bg-deco-terra text-white py-2.5 px-4" data-id="element-114">
      <div className="flex items-center justify-center gap-2 sm:gap-3 flex-wrap text-xs sm:text-sm font-bold tracking-wide" data-id="element-115">
        <div className="flex items-center gap-1.5" data-id="element-116">
          <Flame size={14} className="shrink-0" data-id="element-117" />
          <span className="uppercase" data-id="element-118">Oferta especial</span>
        </div>
        <span className="hidden sm:inline text-white/60" data-id="element-119">—</span>
        <span className="text-white/90 font-medium" data-id="element-120">Termina en</span>
        <div className="flex items-center gap-1 font-mono" data-id="element-121">
          <motion.span key={`m-${timeLeft.minutes}`} initial={{
          scale: 1.15,
          opacity: 0.6
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 0.2
        }} className="bg-white/20 rounded px-1.5 py-0.5 min-w-[28px] text-center" data-id="element-122">
            {pad(timeLeft.minutes)}
          </motion.span>
          <span className="text-white/60" data-id="element-123">:</span>
          <motion.span key={`s-${timeLeft.seconds}`} initial={{
          scale: 1.15,
          opacity: 0.6
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 0.2
        }} className="bg-white/20 rounded px-1.5 py-0.5 min-w-[28px] text-center" data-id="element-124">
            {pad(timeLeft.seconds)}
          </motion.span>
        </div>
      </div>
    </div>;
}